export const business = {
  name: "AFI Trailers",
  legalName: "AFI Rental Trailers, Inc.",
  tagline: "Dump trailer rental",
  phoneDisplay: "(801) 609-4144",
  phoneHref: "tel:8016094144",
  email: "afi.rentaltrailers@gmail.com",
  city: "Spanish Fork, UT",
  address: "Spanish Fork, UT 84660",
  serviceArea: "Serving south Utah County",
  hours: "Mon–Sat 7a–7p",
  facebookUrl:
    "https://www.facebook.com/people/Afi-Rental-Trailers/61566905078603/",
  ownerName: "Landon McKell",
} as const;
